/* __next_internal_client_entry_do_not_use__ default auto */import { useEffect, useState } from "react";
import { useLocale, useMessages } from "next-intl";
import { RenderImportModal } from "./GlobalPopup";
import { isIOS, isMobile } from "react-device-detect";
import { detectClientEnvironment, GenerateIOSLink, GenerateLink } from "@/util";
import { ReportDataInstance } from "@/lib/DataPort";
import EventBus from "@/util/EventBus";
const ImportModal = () => {
  const locale = useLocale();
  const messages = useMessages();
  const [canShowModal, setCanShowModal] = useState(false);
  useEffect(() => {
    const handleScrollEvent = () => setCanShowModal(true);
    EventBus.on("scrollToInnerHeight", handleScrollEvent);
    return () => EventBus.off("scrollToInnerHeight", handleScrollEvent);
  }, []);
  useEffect(() => {
    if (!canShowModal) return;
    (async () => {
      const {
        canAccessInternet
      } = await detectClientEnvironment();
      if (isMobile && canAccessInternet) {
        void RenderImportModal({
          messages,
          locale,
          onOpen() {
            ReportDataInstance.clickOpenImportModal();
            window.open(isIOS ? GenerateIOSLink("h5_seopopup") : GenerateLink("h5_seopopup"));
          },
          onClose() {
            ReportDataInstance.closeOpenImportModal();
          },
          beforeOpenModal() {
            ReportDataInstance.beforeOpenImportModal();
          }
        });
      }
    })();
  }, [canShowModal, messages, locale]);
  return null;
};
export default ImportModal;